import type { RealestateAsset } from "~/types/assets.types";

export const calculateRealestateTotalPerYear = (
  userProduct: RealestateAsset
) => {
  const cashflows = userProduct?.cashflowsData || [];

  const expensesOptions: Record<string, number> = {
    monthly: 12,
    biMonthly: 6,
    quarterly: 4,
    semiannual: 2,
    yearly: 1,
  };

  const rent = userProduct?.rent || 0;
  const incomeFrequency = userProduct?.incomeFrequency;

  const rentMultiplication = expensesOptions[incomeFrequency?.value || ""] || 0;
  const yearlyRent = rent * rentMultiplication;

  return cashflows.map((cashflow) => {
    const sum = cashflow?.sum || 0;
    const frequency = cashflow?.frequency?.value || "";
    const expenseOption = expensesOptions[frequency] || 0;
    const cashflowType = cashflow?.fixedAmountPercentage;

    if (cashflowType) return ((yearlyRent * sum) / 100) * (12 / expenseOption);

    return sum * expenseOption;
  });
};
